import React, { useState } from "react";
import "./ButtonsBarDisconnected.scss";
import BtnBlanc from "../..//Boutons/BtnBlanc/btn-blanc";
import { FaMedal } from "react-icons/fa";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { updateAuth } from "Redux/Actions/authActions";
import ModalConnexion from "Components/Modal/ModalConnexion/ModalConnexion";
import { GiLaurels } from "react-icons/gi";
import ModalAuthentificationEntreprise from "Components/Modal/ModalAuthentificationEntreprise/ModalAuthentificationEntreprise";

const ButtonsBarDisconnected = () => {
  const [visibleModal, setVisibleModal] = useState(false);
  const [authEntreprise, setAuthEntreprise] = useState(false);

  const [alumni, setAlumni] = useState(false);
  const [extraInfo, setExtraInfo] = useState(null);

  return (
    <div className="buttonsBarDisconnected">
      <ModalConnexion
        visibleModal={visibleModal}
        setVisibleModal={setVisibleModal}
        alumni={alumni}
        extraInfo={extraInfo}
      />
      {/* <div className="buttons_bar"> */}
      <h2>ACCÉDEZ À VOTRE ESPACE</h2>
      <div className="buttons">
        <div className="bouton-visible">
          <BtnBlanc
            btnTexte="ÉTUDIANTS  "
            btnAction={() => {
              setAlumni(false);
              setVisibleModal(!visibleModal);
              setExtraInfo('student');
            }}
          >
            {/* <FaUser size={"1rem"} className="icon-button" /> */}
            <i className="pi pi-fw pi-user" />
          </BtnBlanc>
        </div>

        <div className="bouton-visible">
          <BtnBlanc
            btnTexte="ALUMNI  "
            btnAction={() => {
              setAlumni(true);
              setVisibleModal(!visibleModal);
              setExtraInfo('alumni');
            }}
          >
            <GiLaurels className="icon-button"></GiLaurels>
          </BtnBlanc>
        </div>

        <div className="bouton-visible">
          <BtnBlanc
            btnTexte="ENTREPRISES"
            btnAction={() => {
              setAuthEntreprise(true);
            }}
          >
            <i className="pi pi-fw pi-building buildingLogo" />
            {/* <FaHotel size={"1rem"} className="icon-button" /> */}
          </BtnBlanc>
        </div>

        <div className="bouton-visible personnel">
          <BtnBlanc
            btnTexte="PERSONNEL UNIVERSITAIRE  "
            btnAction={() => setVisibleModal(!visibleModal)}
          >
            <FaMedal size={"1rem"} className="icon-button" />
          </BtnBlanc>
        </div>
      </div>
      {authEntreprise && (
        <ModalAuthentificationEntreprise
          authEntrepriseVisible={authEntreprise}
          setAuthEntrepriseVisible={setAuthEntreprise}
          authState="login"
        />
      )}
    </div>
  );
};

ButtonsBarDisconnected.propTypes = {
  auth: PropTypes.object,
  handleAuth: PropTypes.func,
};

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
  handleAuth: (value) => {
    dispatch(updateAuth(value));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ButtonsBarDisconnected);
